import { LOGIN, USER_DETAILS, CONFIG } from "../../constants/apis";
import * as TYPES from "../../constants/actionTypes";
import get from "lodash/get";
import { getUrl } from "../../utilities/helpers";

export const login =
  (credientials) =>
  (dispatch, getState, { apiAuth, apiReport }) =>
    apiAuth
      .post(LOGIN, {
        email: get(credientials, "email"),
        password: get(credientials, "password"),
      })
      .then((result) => {
        apiAuth.defaults.headers.common.authorization = `Bearer ${get(
          result,
          "token"
        )}`;

        apiReport.defaults.headers.common.authorization = `Bearer ${get(
          result,
          "token"
        )}`;

        dispatch({
          type: TYPES.LOGIN,
          payload: {
            ...result,
          },
        });
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const userDetails =
  () =>
  (dispatch, getState, { apiAuth }) =>
    apiAuth
      .get(USER_DETAILS)
      .then((result) => {
        dispatch({
          type: TYPES.USER_DETAILS,
          payload: {
            ...result,
          },
        });
        dispatch({ type: TYPES.LOCATION_UPDATE, payload: result });
      })
      .catch((error) => {
        throw error;
      });

export const logout =
  () =>
  (dispatch, getState, { apiAuth, apiReport }) => {
    apiAuth.defaults.headers.common.authorization = undefined;
    apiReport.defaults.headers.common.authorization = undefined;
    dispatch({
      type: TYPES.LOGOUT,
    });
  };

export const fetchConfig =
  (query) =>
  (dispatch, getState, { apiReport }) =>
    apiReport
      .get(getUrl(CONFIG, { query }))
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
